import { Component, input, inject, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule, MatTable } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ResourceUrlForm, createDocumentationLinkGroup } from '../../utilities/helpers/tool-form.forms';

@Component({
  selector: 'documentation-links-table',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatTableModule, MatFormFieldModule, MatInputModule],
  templateUrl: './documentation-links-table.component.html',
  styleUrls: ['./documentation-links-table.component.scss']
})
export class DocumentationLinksTableComponent {
  private readonly fb = inject(FormBuilder);

  documentationLinks = input.required<FormArray<FormGroup<ResourceUrlForm>>>();

  readonly table = viewChild<MatTable<unknown>>('docTable');
  readonly displayedColumns = ['title', 'url', 'actions'];
  
  addLink(): void {
    this.documentationLinks().push(createDocumentationLinkGroup(this.fb));
    this.renderTable();
  }

  removeLink(index: number): void {
    this.documentationLinks().removeAt(index);
    this.ensureAtLeastOne();
    this.renderTable();
  }

  private ensureAtLeastOne(): void {
    if (this.documentationLinks().length === 0) {
      this.documentationLinks().push(createDocumentationLinkGroup(this.fb));
    }
  }

  private renderTable(): void {
    this.table()?.renderRows();
  }

  ngAfterViewInit(): void {
    this.renderTable();

    const arr = this.documentationLinks();
    arr?.valueChanges?.subscribe(() => this.renderTable());
  }
}
